import type { SubscriptionProduct, AssertProduct } from '@/store/products'

declare const _prd_8IsoMm2bBoXo: {
	id: 'prd_8IsoM2DEV2m2bBoXo'
	ident: 'prd_8IsoMm2bBoXo'
	sku: 'simple_premium_1w_3_99_1w_19_99_usd'
	type: 'subscription'
	phases: [
		{
			type: 'trial'
			interval_unit: 'week'
			interval_duration: 1
			iteration_count: 1
			price_id: 'prc_TYfPv2DEV2vzPB9z0'
			amount: 19.99
			amount_usd: 3.99
			cancellation_fee: null
			currency: 'USD'
			amount_with_discount: 3.99
			discount: 16
			promocode: 'BASE'
		},
		{
			type: 'regular'
			interval_unit: 'week'
			interval_duration: 1
			iteration_count: null
			price_id: 'prc_zWsJf2DEV2hQwgVj5'
			amount: 19.99
			amount_usd: 19.99
			cancellation_fee: null
			currency: 'USD'
		},
	]
}
type _check = AssertProduct<typeof _prd_8IsoMm2bBoXo, SubscriptionProduct>
const prd_8IsoMm2bBoXo = { ident: 'prd_8IsoMm2bBoXo' } as typeof _prd_8IsoMm2bBoXo

export default prd_8IsoMm2bBoXo
